import { Divider, Grid, Typography } from '@mui/material';
import EventFormAssetsItem from 'app/event/eventForm/EventFormAssetsItem';
import EventItemCarousel from 'app/event/eventForm/common/EventItemCarousel';
import ActionButton from 'common/components/ActionButton';
import EmptyTypes from 'common/enums/emptyTypes';
import EmptyView from 'common/features/noData/EmptyView';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAssets } from 'redux/slices/assetSlice';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            minHeight: theme.spacing(24),
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
                gap: theme.spacing(8),
            },
        },
        card: {
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        divider: {
            minHeight: 'inherit',
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
    };
});

const ShortVideoFormConfirm = (props) => {
    const { data, cancel, onSubmit, pending } = props;
    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const assets = useSelector(getAssets);

    return (
        <div>
            <div className={cx(flexBox.flex, flexBox.justifySpaceBetween, flexBox.alignItemsCenter, classes.root)}>
                <div className={cx(flexBox.flex, flexBox.column, flexBox.gap2, flexBox.w30, classes.card)}>
                    <div>
                        <Typography>{t('contact.name')}:</Typography>
                        <Typography>{data.name}</Typography>
                    </div>
                    <div>
                        <Typography>{t('event.eventFormSettings.description')}:</Typography>
                        <Typography>{data.description}</Typography>
                    </div>
                </div>
                <Divider orientation="vertical" className={classes.divider} />
                <div
                    className={cx(
                        flexBox.flex,
                        flexBox.w60,
                        flexBox.column,
                        flexBox.justifyContentCenter,
                        assets?.length && classes.card,
                    )}
                >
                    {assets?.length ? (
                        <EventItemCarousel upcomingLength={assets?.length}>
                            <Grid container spacing={1} wrap="nowrap" column>
                                {assets.map((asset, idx) => {
                                    return (
                                        <Grid key={idx} item sm={6}>
                                            <EventFormAssetsItem asset={asset} />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </EventItemCarousel>
                    ) : (
                        <EmptyView
                            className={cx(flexBox.sticky, flexBox.w100)}
                            size="small"
                            type={EmptyTypes.EMPTY_PRODUCTS}
                            description={t('shortVideo.form.emptyAssets')}
                        />
                    )}
                </div>
            </div>

            <div className={cx(flexBox.flex, flexBox.gap1, flexBox.justifyContentEnd, flexBox.paddingTop2)}>
                <ActionButton disabled={pending} onClick={cancel} color="default" fitWidth>
                    {t('multimedia.multimediaForm.cancel')}
                </ActionButton>

                <ActionButton
                    disabled={pending}
                    color="primary"
                    type="submit"
                    autoFocus
                    fitWidth
                    onClick={onSubmit}
                    spinner={pending}
                >
                    {t('game.gameActions.save')}
                </ActionButton>
            </div>
        </div>
    );
};

export default ShortVideoFormConfirm;
